import React, { useEffect, useState, useRef } from 'react';
export function CustomCursor() {
  const cursorRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isButton, setIsButton] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Only show custom cursor on devices with a fine pointer (mouse)
    if (window.matchMedia('(pointer: coarse)').matches) return;
    setIsVisible(true);
    const updateMousePosition = (e: MouseEvent) => {
      if (cursorRef.current) {
        // Direct DOM manipulation for performance (no React re-renders)
        cursorRef.current.style.transform = `translate3d(${e.clientX - 10}px, ${e.clientY - 10}px, 0) scale(${isHovering ? 1.5 : 1})`;
      }
    };
    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isInteractive = target.tagName === 'BUTTON' || target.tagName === 'A' || target.closest('button') !== null || target.closest('a') !== null;
      const isButtonElement = target.tagName === 'BUTTON' || target.closest('button') !== null;
      setIsHovering(isInteractive);
      setIsButton(isButtonElement);
      // Update transform immediately on hover state change
      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate3d(${e.clientX - 10}px, ${e.clientY - 10}px, 0) scale(${isInteractive ? 1.5 : 1})`;
      }
    };
    window.addEventListener('mousemove', updateMousePosition, {
      passive: true
    });
    window.addEventListener('mouseover', handleMouseOver, {
      passive: true
    });
    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, [isHovering]); // Re-bind when hover state changes to use correct scale in mousemove
  if (!isVisible) return null;
  return <div ref={cursorRef} className="fixed top-0 left-0 pointer-events-none z-[9999] mix-blend-difference" style={{
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: isButton ? '#D4AF37' : '#F5F5F5',
    transition: 'background-color 0.2s ease, transform 0.1s ease-out',
    willChange: 'transform'
  }} data-id="element-86" />;
}